<template>
  <div class="page-container">
    <div class="page-header">
      <picture class="banner-picture">
        <source media="(max-width: 768px)" srcset="/official/assets/static/contents/sitefiles2047/10237182/images/55077630.png" />
        <img class="banner-bg" src="/official/assets/static/contents/sitefiles2047/10237182/images/55077630.png" alt="" />
      </picture>
      <div class="banner-overlay"></div>
      <div class="container">
        <h1>我们的服务</h1>
        <p class="subtitle">全方位的检测解决方案，满足您的多样化需求</p>
      </div>
    </div>
    
    <div class="container content">
      <!-- Services Grid -->
      <div class="section-block">
        <div class="services-grid">
          <div class="service-item" v-for="(service, index) in services" :key="index">
            <div class="icon-box">
              <span class="service-icon">{{ service.icon }}</span>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.desc }}</p>
            <ul class="feature-list">
              <li v-for="(item, idx) in service.items" :key="idx">{{ item }}</li>
            </ul>
            <button class="consult-btn" @click="dialPhoneNumber">立即咨询</button>
          </div>
        </div>
      </div>
      
      <!-- Service Process -->
      <div class="section-block process-section">
        <h2 class="block-title">服务流程</h2>
        <div class="process-steps">
          <div class="step-item">
            <div class="step-num">01</div>
            <h4>业务咨询</h4>
            <p>确认检测需求与标准</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">02</div>
            <h4>样品受理</h4>
            <p>填写委托单并送样</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">03</div>
            <h4>实验检测</h4>
            <p>专业实验室分析测试</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">04</div>
            <h4>报告出具</h4>
            <p>审核并签发检测报告</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">05</div>
            <h4>售后服务</h4>
            <p>报告解读与技术支持</p>
          </div>
        </div>
      </div>
      
      <!-- FAQ -->
      <div class="section-block faq-section">
        <h2 class="block-title">常见问题</h2>
        <div class="faq-list">
          <div class="faq-item" v-for="(faq, i) in faqs" :key="i">
            <div class="faq-question">Q: {{ faq.q }}</div>
            <div class="faq-answer">A: {{ faq.a }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const services = [
      {
        icon: '📏',
        title: '计量校准',
        desc: '覆盖十大计量领域，为仪器设备提供专业量值溯源服务。',
        items: ['几何量学', '力学与热工', '电磁与无线电', '时间频率与化学']
      },
      {
        icon: '⚡',
        title: '电力设备检测',
        desc: '面向高低压设备及电力安全工器具提供检验检测服务。',
        items: ['交直流高压试验', '力学性能试验', '绝缘安全工器具', '高低压电气设备']
      },
      {
        icon: '🎓',
        title: '技术培训',
        desc: '国测学院提供质量管理与检测技术专业课程。',
        items: ['质量体系培训', '检测技术培训', '实验室管理', '质量管理课程']
      },
      {
        icon: '🧭',
        title: '体系认证',
        desc: '围绕企业质量体系建设提供专业认证支持。',
        items: ['体系建设辅导', '内审员培训', '管理流程优化', '认证准备支持']
      },
      {
        icon: '🔬',
        title: '科研与标准',
        desc: '推动检测新技术、新方法的开发与应用。',
        items: ['检测方法开发', '标准研讨制定', '产业技术研究', '产学研合作']
      },
      {
        icon: '💬',
        title: '技术咨询',
        desc: '提供专业的实验室管理及认证咨询服务。',
        items: ['CMA/CNAS咨询', '实验室规划设计', '质量能力提升', '技术方案服务']
      }
    ]
    
    const faqs = [
      {
        q: '检测周期一般是多久？',
        a: '常规项目检测周期为5-7个工作日，加急服务可缩短至2-3个工作日（需视具体项目而定）。'
      },
      {
        q: '如何送样？',
        a: '您可以直接将样品邮寄至我司实验室，或联系客服预约上门采样服务。'
      },
      {
        q: '检测报告具有法律效力吗？',
        a: '是的，我司出具的带CMA章的检测报告具有法律效力，可用于司法鉴定、行政处罚、社会仲裁等。'
      }
    ]
    
    const dialPhoneNumber = () => {
      window.location.href = 'tel:053188896650';
    }
    
    return {
      services,
      faqs,
      dialPhoneNumber
    }
  }
}
</script>

<style scoped>
.page-header {
  padding: 0;
  margin-bottom: 60px;
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 1;
  display: flex;
  align-items: center;
}

.banner-picture {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: none;
}

.banner-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.08;
  background:
    radial-gradient(650px 360px at 15% 25%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 62%),
    radial-gradient(620px 360px at 85% 45%, rgba(255, 214, 102, 0.04) 0%, rgba(255, 214, 102, 0) 64%),
    linear-gradient(135deg, rgba(0, 104, 183, 0.40) 0%, rgba(0, 71, 133, 0.34) 100%);
  z-index: 1;
}

.banner-overlay::before {
  content: '';
  position: absolute;
  inset: -25%;
  background:
    radial-gradient(closest-side at 18% 30%, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0)),
    radial-gradient(closest-side at 82% 42%, rgba(255, 189, 92, 0.18), rgba(255, 189, 92, 0)),
    radial-gradient(closest-side at 55% 90%, rgba(160, 132, 255, 0.18), rgba(160, 132, 255, 0));
  filter: blur(22px);
  opacity: 0.9;
  animation: pageBannerBlobs 18s ease-in-out infinite alternate;
}

.banner-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 10px 10px, rgba(255, 255, 255, 0.14) 2px, rgba(255, 255, 255, 0) 3px),
    radial-gradient(circle at 48px 60px, rgba(255, 255, 255, 0.10) 1px, rgba(255, 255, 255, 0) 2px);
  background-size: 70px 70px, 140px 140px;
  opacity: 0.18;
  animation: pageBannerParticles 26s linear infinite;
  pointer-events: none;
}

.page-header .container {
  display: none;
}

.page-header h1 {
  margin: 0 0 15px 0;
  font-size: 2.5rem;
  font-weight: 700;
  animation: pageFadeUp 700ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
  letter-spacing: 1px;
  animation: pageFadeUp 800ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@media (max-width: 768px) {
  .page-header {
    aspect-ratio: 4 / 5;
  }
}

@keyframes pageFadeUp {
  from { opacity: 0; transform: translate3d(0, 10px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes pageBannerZoom {
  from { transform: scale(1.06); }
  to { transform: scale(1.12); }
}

@keyframes pageBannerBlobs {
  0% { transform: translate3d(-1%, -1%, 0) scale(1); }
  50% { transform: translate3d(2%, 2%, 0) scale(1.03); }
  100% { transform: translate3d(-2%, 3%, 0) scale(1.02); }
}

@keyframes pageBannerParticles {
  from { background-position: 0 0, 0 0; }
  to { background-position: 0 -420px, 0 -840px; }
}

@media (prefers-reduced-motion: reduce) {
  .banner-bg,
  .banner-overlay::before,
  .banner-overlay::after,
  .page-header h1,
  .subtitle {
    animation: none !important;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content {
  padding-bottom: 80px;
}

.section-block {
  margin-bottom: 80px;
}

.block-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 50px;
  text-align: center;
  position: relative;
  padding-bottom: 15px;
}

.block-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #0068b7;
}

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
}

.service-item {
  background: #fff;
  border: 1px solid #f0f0f0;
  padding: 40px 30px;
  border-radius: 12px;
  transition: all 0.3s;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
}

.service-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 104, 183, 0.1);
  border-color: #e0d4f5;
}

.icon-box {
  width: 70px;
  height: 70px;
  background-color: #f8f4fc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  transition: all 0.3s;
}

.service-item:hover .icon-box {
  background-color: #0068b7;
  color: #fff;
}

.service-icon {
  font-size: 32px;
}

.service-item h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  color: #333;
}

.service-item p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
  min-height: 48px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
  color: #555;
  flex: 1;
}

.feature-list li {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.feature-list li::before {
  content: "✓";
  color: #0068b7;
  margin-right: 10px;
  font-weight: bold;
}

.consult-btn {
  background-color: transparent;
  border: 1px solid #0068b7;
  color: #0068b7;
  padding: 10px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 600;
  width: 100%;
}

.service-item:hover .consult-btn {
  background-color: #0068b7;
  color: #fff;
}

/* Process Section */
.process-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.step-item {
  text-align: center;
  flex: 1;
  position: relative;
  z-index: 2;
}

.step-num {
  width: 60px;
  height: 60px;
  background-color: #fff;
  border: 2px solid #0068b7;
  color: #0068b7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 20px;
  transition: all 0.3s;
}

.step-item:hover .step-num {
  background-color: #0068b7;
  color: #fff;
  transform: scale(1.1);
}

.step-item h4 {
  margin-bottom: 10px;
  color: #333;
}

.step-item p {
  color: #666;
  font-size: 0.9rem;
}

.step-line {
  flex: 1;
  height: 2px;
  background-color: #e0d4f5;
  margin-top: 30px;
}

/* FAQ Section */
.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border: 1px solid #f0f0f0;
}

.faq-question {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.faq-answer {
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .step-line {
    display: none;
  }
  
  .step-item {
    width: 100%;
  }
}
</style>
